import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    theme: localStorage.getItem('theme') || 'light',
    language: localStorage.getItem('language') || 'ko',
    notifications: JSON.parse(localStorage.getItem('notifications') || 'true'),
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.theme = action.payload;
            localStorage.setItem('theme', action.payload);
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
            localStorage.setItem('language', action.payload);
        },
        setNotifications: (state, action) => {
            state.notifications = action.payload;
            localStorage.setItem('notifications', JSON.stringify(action.payload));
        },
    },
});

export const { setTheme, setLanguage, setNotifications } = settingsSlice.actions;
export default settingsSlice.reducer;